import {
  CREATE_CCPA_REQUEST,
  CREATE_CCPA_REQUEST_SUCCESS,
  CREATE_CCPA_REQUEST_ERROR,
  SHOW_TOAST_ALERT,
  RESET_TOAST_MESSAGE,

} from "./actionTypes"

const INIT_STATE = {
  ccpa_request: [],
  error: null,
  loading: false,
  toastMessage: null
}
const QuoteFunnelsCCPA = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_CCPA_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case CREATE_CCPA_REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        ccpa_request: action.payload,
        loading: false,
      }

    case CREATE_CCPA_REQUEST_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    
    case SHOW_TOAST_ALERT:
      return {
        ...state,
        toastMessage: action.payload,
      }

    
    case RESET_TOAST_MESSAGE:
      return {
        ...state,
        toastMessage: null,
      }

    default:
      return state
  }
}

export default QuoteFunnelsCCPA
